import React, { useState } from "react";
import "./styles/PacientesSocial.css";

const PacientesSocial = () => {
  const [posts, setPosts] = useState([
    {
      id: 1,
      user_name: "Dr. Ana Silva",
      user_profile_pic: "https://randomuser.me/api/portraits/women/44.jpg",
      content: "Acabei de publicar um novo artigo sobre hipertensão em jovens adultos. Confira no link abaixo!",
      likes: 24,
      comments: 5,
      created_at: "2023-09-15T14:30:00Z",
      type: "professional"
    },
    {
      id: 2,
      user_name: "Clínica Saúde Total",
      user_profile_pic: "https://randomuser.me/api/portraits/lego/5.jpg",
      content: "Estamos com horários disponíveis para consultas de cardiologia e pneumologia na próxima semana! Agende pelo nosso site ou aplicativo.",
      likes: 8, 
      comments: 2,
      created_at: "2023-09-14T09:15:00Z",
      type: "business"
    },
    {
      id: 3,
      user_name: "Hospital São Lucas",
      user_profile_pic: "https://randomuser.me/api/portraits/lego/2.jpg",
      content: "Campanha de vacinação contra a gripe! Traga sua família para se proteger antes do inverno.",
      likes: 42,
      comments: 7,
      created_at: "2023-09-13T11:20:00Z",
      type: "business"
    }
  ]);

  const [activeTab, setActiveTab] = useState('all');
  const [activeFilter, setActiveFilter] = useState('all');
  const [commentingOn, setCommentingOn] = useState(null);
  const [commentText, setCommentText] = useState("");
  const [likedPosts, setLikedPosts] = useState([]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleLike = (postId) => {
    if (likedPosts.includes(postId)) {
      // Unlike
      setLikedPosts(prev => prev.filter(id => id !== postId));
      setPosts(prev => prev.map(post => 
        post.id === postId ? {...post, likes: post.likes - 1} : post
      ));
    } else {
      // Like
      setLikedPosts(prev => [...prev, postId]);
      setPosts(prev => prev.map(post => 
        post.id === postId ? {...post, likes: post.likes + 1} : post
      ));
    }
  };

  const handleCommentClick = (postId) => {
    setCommentingOn(commentingOn === postId ? null : postId);
    setCommentText("");
  };

  const handleCommentSubmit = (postId, e) => {
    e.preventDefault();
    if (!commentText.trim()) return;

    // Add comment logic
    setPosts(prev => prev.map(post => 
      post.id === postId ? {...post, comments: post.comments + 1} : post
    ));
    setCommentText("");
    setCommentingOn(null);
  };

  const handleFollow = (userId) => {
    // Follow logic would go here
    console.log("Seguindo usuário:", userId);
  };

  // Filter posts based on active tab and filter
  const filteredPosts = posts.filter(post => {
    if (activeFilter !== 'all') {
      const filterType = activeFilter === 'professionals' ? 'professional' : 'business';
      if (post.type !== filterType) return false;
    }
    return true;
  });

  return (
    <div className="pacientes-social-container">
      <div className="social-header">
        <h2>Feed Social</h2>
        <p>Fique por dentro das notícias e novidades da comunidade médica.</p>
        
        <div className="filter-section">
          <div className="tabs">
            <button 
              className={`tab ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => setActiveTab('all')}
            >
              Todos
            </button>
            <button 
              className={`tab ${activeTab === 'following' ? 'active' : ''}`}
              onClick={() => setActiveTab('following')}
            >
              Seguindo
            </button>
            <button 
              className={`tab ${activeTab === 'local' ? 'active' : ''}`}
              onClick={() => setActiveTab('local')}
            >
              Minha Cidade
            </button>
          </div>
          
          <div className="type-filters">
            <button 
              className={`filter ${activeFilter === 'all' ? 'active' : ''}`}
              onClick={() => setActiveFilter('all')}
            >
              Todos
            </button>
            <button 
              className={`filter ${activeFilter === 'professionals' ? 'active' : ''}`}
              onClick={() => setActiveFilter('professionals')}
            >
              Profissionais
            </button>
            <button 
              className={`filter ${activeFilter === 'businesses' ? 'active' : ''}`}
              onClick={() => setActiveFilter('businesses')}
            >
              Clínicas
            </button>
          </div>
        </div>
      </div>

      <div className="posts-container">
        {filteredPosts.length === 0 ? (
          <div className="no-posts">
            <p>Nenhuma publicação encontrada.</p>
          </div>
        ) : (
          filteredPosts.map(post => (
            <div key={post.id} className="post-card">
              <div className="post-header">
                <img 
                  src={post.user_profile_pic} 
                  alt={post.user_name}
                  className="user-avatar" 
                />
                <div className="post-meta">
                  <div className="name-follow">
                    <h3>{post.user_name}</h3>
                    <button 
                      className="follow-button"
                      onClick={() => handleFollow(post.id)}
                    >
                      Seguir
                    </button>
                  </div>
                  <div className="post-info">
                    <span className="post-type">
                      {post.type === 'professional' ? 'Profissional de saúde' : 'Negócio'}
                    </span>
                    <span className="post-date">{formatDate(post.created_at)}</span>
                  </div>
                </div>
              </div>
              
              <div className="post-content">
                <p>{post.content}</p>
              </div>
              
              <div className="post-actions">
                <button 
                  className={`like-button ${likedPosts.includes(post.id) ? 'liked' : ''}`}
                  onClick={() => handleLike(post.id)}
                >
                  {likedPosts.includes(post.id) ? '❤️' : '🤍'} <span>{post.likes}</span>
                </button>
                
                <button 
                  className="comment-button"
                  onClick={() => handleCommentClick(post.id)}
                >
                  💬 <span>{post.comments}</span>
                </button>
              </div>
              
              <div className={`comment-input-area ${commentingOn === post.id ? 'visible' : ''}`}>
                <form className="comment-form" onSubmit={(e) => handleCommentSubmit(post.id, e)}>
                  <input
                    type="text"
                    className="comment-input"
                    placeholder="Escreva um comentário..."
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                  />
                  <button type="submit" className="comment-submit">Enviar</button>
                </form>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default PacientesSocial;